/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Trust_TitleInputs */

const en_directory_agents_trust_title = /** @type {(inputs: Directory_Agents_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trust boundaries`)
};

const zh_directory_agents_trust_title = /** @type {(inputs: Directory_Agents_Trust_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信任边界`)
};

/**
* | output |
* | --- |
* | "Trust boundaries" |
*
* @param {Directory_Agents_Trust_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_trust_title = /** @type {((inputs?: Directory_Agents_Trust_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Trust_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_trust_title(inputs)
	return zh_directory_agents_trust_title(inputs)
});
export { directory_agents_trust_title as "directory.agents.trust_title" }